import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import http from '@/services/http';
import { DEFAULT_HEADERS } from '@/services/constants.service';
import { getUserProfile } from '@/services/user.service';

const announcementModalSlice = (set) => ({
  // Modal state
  isOpen: false,
  isLoading: false,
  hasBeenShown: false,
  // When the user last logged in (set on just_logged_in or first authenticated load); used to show modal 24h later
  loginTimestamp: null,
  // Set to true when persist has rehydrated from localStorage (so we know loginTimestamp is final)
  _hasRehydrated: false,

  // Actions
  setIsOpen: (isOpen) => set({ isOpen }),
  setIsLoading: (isLoading) => set({ isLoading }),
  setHasBeenShown: (hasBeenShown) => set({ hasBeenShown }),
  setLoginTimestamp: (loginTimestamp) => set({ loginTimestamp }),

  // Check if modal should be shown (once per user)
  checkAndShowModal: async () => {
    return false;
    try {
      set({ isLoading: true });

      // Fetch user profile to check if modal has been seen
      try {
        const profileResponse = await getUserProfile();
        const profile = profileResponse.data;
        const seen = profile.seen_new_design_popup;

        // If modal has NOT been seen (false), show it
        if (seen === false) {
          set({ isOpen: true, hasBeenShown: true, isLoading: false });
          return true;
        } else {
          set({ isLoading: false });
          return false;
        }
      } catch (error) {
        set({ isLoading: false });
        return false;
      }
    } catch (error) {
      set({ isLoading: false });
      return false;
    }
  },

  // Handle modal close
  handleClose: () => {
    // Close modal immediately without waiting for tracking
    set({ isOpen: false });

    // Fire tracking request in background (don't await)
    http.post(
      import.meta.env.VITE_APP_BASE_API + 'pop_up_track/?event_type=new_design_modal_shown',
      {},
      { headers: DEFAULT_HEADERS }
    ).catch((error) => {
      console.error('Error tracking close event:', error);
    });
  },

  // Handle Explore Platform action
  handleExplorePlatform: () => {
    // Fire tracking request in background (don't await)
    http.post(
      import.meta.env.VITE_APP_BASE_API + 'pop_up_track/?event_type=new_design_modal_shown',
      {},
      { headers: DEFAULT_HEADERS }
    ).catch((error) => {
      console.error('Error tracking explore platform event:', error);
    });
  },

  // Handle Read Changelog action
  handleReadChangelog: () => {
    // Fire tracking request in background (don't await)
    http.post(
      import.meta.env.VITE_APP_BASE_API + 'pop_up_track/?event_type=new_design_modal_shown',
      {},
      { headers: DEFAULT_HEADERS }
    ).catch((error) => {
      console.error('Error tracking changelog event:', error);
    });
  },

  // Reset store (for logout)
  reset: () => set({
    isOpen: false,
    isLoading: false,
    hasBeenShown: false,
    loginTimestamp: null,
    _hasRehydrated: false
  })
});

let storeRef;
const useAnnouncementModalStore = create(
  persist(announcementModalSlice, {
    name: 'announcementModal',
    partialize: (state) => ({ loginTimestamp: state.loginTimestamp }),
    onRehydrateStorage: () => (state, err) => {
      setTimeout(() => { if (storeRef) storeRef.setState({ _hasRehydrated: true }); }, 0);
    }
  })
);
storeRef = useAnnouncementModalStore;

export default useAnnouncementModalStore;
